import React from 'react';

export const BubbleIcon = (props) => (
  <svg {...props} viewBox="0 0 479.058 479.058" xmlns="http://www.w3.org/2000/svg">
    <path d="m239.529 449.117h-224.558c-5.804 0-11.096-3.363-13.552-8.626-2.471-5.248-1.667-11.462 2.047-15.935l47.075-56.49c-32.69-36.74-50.541-81.9-50.541-128.537 0-115.569 107.455-209.588 239.529-209.588s239.529 94.019 239.529 209.588-107.455 209.588-239.529 209.588zm-192.6-29.941h192.6c115.568 0 209.588-80.584 209.588-179.647s-94.02-179.647-209.588-179.647-209.588 80.584-209.588 179.647c0 42.923 18.172 84.575 51.154 117.279 5.512 5.468 5.936 14.24.965 20.204.001 0-35.13 42.163-35.131 42.164z" />
  </svg>
);

export default BubbleIcon;
